var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-backup-status-dropdown"},[_c('i-dropdown',{attrs:{"label":_vm.label,"options":_vm.options,"placeholder":"All","allow-empty":false},on:{"input":_vm.onInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }